<pdq-card variant="popover" color="white">
  <div class="card">
    <div class="card__header">
      <pdq-heading element="h5">Appearance</pdq-heading>
      <pdq-button
        class="collapse-chevron"
        [class.collapse-chevron--open]="!appearanceCollapsed"
        icon="arrow_down"
        variant="ghost"
        plain="true"
        size="large"
        iconColor="var(--on-surface-default)"
        (onClick)="toggleAppearanceCollapsed()"></pdq-button>
    </div>
    @if (!appearanceCollapsed) {
      <pdq-divider></pdq-divider>
      <div class="card__content" [formGroup]="formGroup.controls.appearance">
        <div class="field">
          <span class="field__label">Bar Type</span>
          <pdq-radio-group [formControl]="formGroup.controls.appearance.controls.barType" variant="segmented">
            <pdq-radio-button value="sequential" text="Sequential"></pdq-radio-button>
            <pdq-radio-button value="inline" text="Inline"></pdq-radio-button>
            <pdq-radio-button value="single_bar" text="Single Bar"></pdq-radio-button>
          </pdq-radio-group>
        </div>

        <div class="field" [formGroup]="formGroup.controls.appearance.controls.pills">
          <pdq-checkbox
            [formControl]="formGroup.controls.appearance.controls.pills.controls.enabled"
            label="Show Previous Goals As Pills"
            secondaryLabel="Pills use your goal labels. Enable labels in goal settings to show them."
            labelSize="small"></pdq-checkbox>
        </div>

        @if (formGroup.controls.appearance.controls.pills.controls.enabled.value) {
          <div class="field-row">
            <div class="field">
              <span class="field__label">Background color</span>
              <pdq-input-color
                [formControl]="formGroup.controls.appearance.controls.pills.controls.backgroundColor"></pdq-input-color>
            </div>
            <div class="field">
              <span class="field__label">Text color</span>
              <pdq-input-color
                [formControl]="formGroup.controls.appearance.controls.pills.controls.textColor"></pdq-input-color>
            </div>
          </div>
          <div class="field">
            <span class="field__label">Corner Radius</span>
            <pdq-input-arrows
              [formControl]="formGroup.controls.appearance.controls.pills.controls.cornerRadius"
              widthSize="fullwidth"
              [min]="0"
              [required]="false"
              placeholder="0"></pdq-input-arrows>
          </div>
        }

        <span class="subsection__title">Background</span>
        <div class="field-row" [formGroup]="formGroup.controls.appearance.controls.background">
          <div class="field">
            <span class="field__label">Color</span>
            <pdq-input-color
              [formControl]="formGroup.controls.appearance.controls.background.controls.color"></pdq-input-color>
          </div>
          <div class="field">
            <span class="field__label">Padding</span>
            <pdq-dropdown
              [formControl]="formGroup.controls.appearance.controls.background.controls.padding"
              [options]="paddingOptions"
              fullWidth="true"></pdq-dropdown>
          </div>
        </div>

        <div class="field">
          <span class="field__label">Corner Radius</span>
          <pdq-input-arrows
            [formControl]="formGroup.controls.appearance.controls.background.controls.cornerRadius"
            widthSize="fullwidth"
            [min]="0"
            [required]="false"
            placeholder="0"></pdq-input-arrows>
        </div>

        <div class="field" [formGroup]="formGroup.controls.appearance.controls.background.controls.border">
          <pdq-checkbox
            [formControl]="formGroup.controls.appearance.controls.background.controls.border.controls.enabled"
            label="Border"
            labelSize="small"></pdq-checkbox>
        </div>

        @if (formGroup.controls.appearance.controls.background.controls.border.controls.enabled.value) {
          <div class="field-row">
            <div class="field">
              <span class="field__label">Border width</span>
              <pdq-input-arrows
                [formControl]="formGroup.controls.appearance.controls.background.controls.border.controls.width"
                widthSize="fullwidth"
                [min]="0"
                [required]="false"
                placeholder="0"></pdq-input-arrows>
            </div>
            <div class="field">
              <span class="field__label">Border Color</span>
              <pdq-input-color
                [formControl]="
                  formGroup.controls.appearance.controls.background.controls.border.controls.color
                "></pdq-input-color>
            </div>
          </div>
        }

        <div class="field" [formGroup]="formGroup.controls.appearance.controls.bottomBorder">
          <pdq-checkbox
            [formControl]="formGroup.controls.appearance.controls.bottomBorder.controls.enabled"
            label="Bottom border"
            labelSize="small"></pdq-checkbox>
          @if (formGroup.controls.appearance.controls.bottomBorder.controls.enabled.value) {
            <pdq-input-color
              [formControl]="formGroup.controls.appearance.controls.bottomBorder.controls.color"></pdq-input-color>
          }
        </div>

        <span class="subsection__title">Progress Bar</span>
        <div class="field" [formGroup]="formGroup.controls.appearance.controls.progressBar">
          <span class="field__label">Color</span>
          <pdq-input-color
            [formControl]="formGroup.controls.appearance.controls.progressBar.controls.color"></pdq-input-color>
        </div>
        <div class="field-row">
          <div class="field">
            <span class="field__label">Bar width</span>
            <pdq-input-arrows
              [formControl]="formGroup.controls.appearance.controls.progressBar.controls.barWidth"
              widthSize="fullwidth"
              [min]="0"
              [required]="false"
              placeholder="0"></pdq-input-arrows>
          </div>
          <div class="field">
            <span class="field__label">Corner Radius</span>
            <pdq-input-arrows
              [formControl]="formGroup.controls.appearance.controls.progressBar.controls.cornerRadius"
              widthSize="fullwidth"
              [min]="0"
              [required]="false"
              placeholder="0"></pdq-input-arrows>
          </div>
        </div>
      </div>
    }
  </div>
</pdq-card>

@if (formGroup.errors?.['autoAppliedOrderDiscountWithDisplayConditions']) {
  <span class="threshold-error">
    Auto-applied order discounts can't be limited by display conditions. Remove the conditions or turn off auto-apply.
  </span>
}

@for (goalCtrl of goalsArray.controls; track goalCtrl.controls.id.value; let goalIndex = $index) {
  <smart-cart-goals-goal-card
    [goal]="goalCtrl"
    [index]="goalIndex"
    [minimumThresholdType]="formGroup.controls.minimumThresholdType"
    [barType]="formGroup.controls.appearance.controls.barType"
    [pillsEnabled]="formGroup.controls.appearance.controls.pills.controls.enabled"
    [globalSettingsFormGroup]="globalSettingsFormGroup"
    [thresholdErrors]="$any(goalsArray.errors?.['thresholdOrder'])"
    [isAutoApplyBlockedByDisplayConditions]="
      !!formGroup.errors?.['autoAppliedOrderDiscountWithDisplayConditions']?.includes(goalIndex)
    "
    [isOnlyGoal]="goalsArray.length === 1"
    [smartCartId]="smartCartId"
    [usageToken]="usageToken"
    (remove)="removeGoal(goalIndex)"></smart-cart-goals-goal-card>
}

<pdq-button class="add-goal" variant="primary" label="+Add Goal" (onClick)="addGoal()"></pdq-button>

<smart-cart-goals-custom-code-card
  [enabledControl]="formGroup.controls.customCode.controls.enabled"
  [codeControl]="formGroup.controls.customCode.controls.code"></smart-cart-goals-custom-code-card>
